export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11380.53d4c183.jpg";